import AOS from 'aos';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicTestimonials {
  constructor(section) {
    this.el = section.el;
    this.data = section.data || {};
    this.carouselEl = this.el.querySelector('[data-splide-carousel]');
    this.splide = null;

    if (!this.carouselEl) {
      return;
    }

    const showThreeSlides = this.data.showThreeSlides === true;

    const options = {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '1rem',
      autoplay: true,
      interval: 6000,
      pagination: true,
      arrows: true,
      rewind: true,
      mediaQuery: 'min',
    };

    if (showThreeSlides) {
      options.breakpoints = {
        [unitlessBreakpoints.lg]: {
          perPage: 3,
          perMove: 1,
          gap: '3.5rem',
        },
      };
    }

    this.splide = new Splide(this.carouselEl, options);
    this.splide.mount();
    AOS.refresh();
  }

  onSectionUnload() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
